import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import RefreshIcon from '@material-ui/icons/Refresh';

import ReactLoading from 'react-loading';
import MenuButton from './buttons/MenuButton';
import OrderItem from "./OrderItemCard";

import getUserOrders from "../functions/getUserOrders";
import downloadOrder from "../functions/downloadOrder";
import reorderData from "../functions/reorderData";

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";

const useStyles = makeStyles({
  root: {
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      height:12,
    }
  },
  containerDiv: {
    border: '1px solid #D2D2D8',
  },
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '80vh',
    minWidth:840
  },
  formLabel:{
      marginLeft: 90,
      marginTop: 40,
      marginBottom: 20,
      color: '#447095',
  },
  formsearch:{
    display:"flex",
    flexDirection:"row",
    marginLeft: 90,
    marginRight: 90,
    marginBottom: 10,
    height: 120,
    backgroundColor: '#ECF4F9',
    flexWrap:"nowrap",
    alignItems: 'flex-start',
  },
  formtable:{
    marginBottom: 20,
    minHeight: 300,
    minWidth: 600,
    color: '#447095',
  },
  searchContainer:{
    paddingBottom:20,
  },
  selectionOptions:{
    width: 200,
    marginRight:20,
    height:12
  },
  selectionDateOptions:{
    maxWidth: 200,
    marginRight:20,
    height:12
  },
  textItemFont:{
    fontSize:11
  },
  searchButton:{
    marginTop: 5,
    height: 28,
    width: 180,
    backgroundColor:'#0C4C35',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#63D764'
    },
  },
  searchIcon: {
    width: 16,
    height: 15
  },
  keywordsField:{
    marginTop: 20,
  },
  downloadIcon: {
    width: 16,
    height: 16
  },
  downloadButton: {
    height: 28,
    width: '90%',
    minWidth: 120,
    maxWidth: 180,
    backgroundColor:'#0C4C35',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#63D764'
    },
  },
});


export default function OrderDialog(props) {

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [uState] = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('lg');
  const [orderRows, setOrderRows] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [timescale, setTimescale] = useState('today');
  const [timecustom, setTimecustom] = useState(false);

  const [keyword, setkeyword] = useState(' ');
  const [selection, setSelection] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setOpen(true);
    getOrdersList();
  };

   /**
     * First load
     */
    useEffect(() => {
      let date = new Date();
      const day= ('0'+date.getDate()).slice(-2);
      const month = ('0'+(date.getMonth()+ 1)).slice(-2);
      setFromDate(date.getFullYear()+'-'+month+'-'+day);
      setToDate(date.getFullYear()+'-'+month+'-'+day);

      if (uState.company.companytype === 'training') { setIsDisabled(true); };
    },[])

    useEffect(() => {
      if (uState.company.companytype === 'training') { setIsDisabled(true); };
    },[uState.company.companytype])

    function getOrdersList() {
      setLoading(true);
      let date = new Date();
      sDispatch({type: "setorders", payload: { orders: [] }});
      getUserOrders(uState.userid, date, date, sDispatch);
    }

    /**
     * Listerns for change to orders list.
     */
    useEffect(() => {
      if (sState.orders.length > 0){
        setOrderRows(sState.orders);
      }
      setLoading(false);
    },[sState.orders])

    useEffect(() => {
      if (timescale === 'custom'){
        setTimecustom(true);
      } else {
        setTimecustom(false);
      }
    },[timescale])

    const filterOrderList =() => {
      let date = new Date();
      let dtFromDate = new Date();
      let dtToDate = new Date();

      switch(timescale){
        default:
        case "today":
          break;
        case "7days":
          dtFromDate.setDate(date.getDate() - 7);
          break;        
        case "thismonth":
          dtFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
          break;
        case "lastmonth":
          //date.setDate(date.getMonth() - 1);
          dtFromDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
          dtToDate = new Date(date.getFullYear(), date.getMonth(), 0);
          break;
        case "custom":
          dtFromDate = new Date(fromDate);
          dtToDate = new Date(toDate);
          break;
      }
      sDispatch({type: "setorders", payload: { orders: [] }});
      getUserOrders(uState.userid, dtFromDate, dtToDate, sDispatch);
    }

    const handleDataRefreshClick = (orderid) => {
      if (typeof orderid !== 'undefined' && orderid !== null){
        reorderData(orderid);
      }
    }

    const handleDownloadClick = (orderid) => {
      if (typeof orderid !== 'undefined' && orderid !== null){
        //console.log("Orderid selected ="+JSON.stringify(orderid));
        downloadOrder(orderid, sState.ident, sState.userid);
      }
    }
    
  return (
      <div className={classes.root}>
      <MenuButton label="My Orders" handleClick={handleSubmit} disabled={isDisabled} tooltip={'Download previously ordered items'} />

      <Dialog open={open} classes={{ paper: classes.dialogPaper }} onClose={e => setOpen(false)} aria-labelledby="form-dialog-title" fullWidth={fullWidth} maxWidth={maxWidth}>
        <DialogTitle id="form-dialog-title" >My Orders</DialogTitle>
        <DialogContent>
          {loading ? (
          <div className={classes.containerDiv}>
            <Box p={1} justifyContent="center"><ReactLoading className={classes.loadingImg} type={"bars"} color={"#63D764"} /></Box>
          </div>
          ) : ('')}
          <Grid container>
              <Grid item xs={12}>
                <Box display="flex" className={classes.searchContainer} justifyContent="flex-start">
                  <Box >
                  <TextField id="listTimescale" label="Show orders from" value={timescale} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.selectionOptions} onChange={e => setTimescale(e.target.value)} select >
                    <MenuItem value={'today'}>Today</MenuItem>
                    <MenuItem value={'7days'}>Last 7 days</MenuItem>
                    <MenuItem value={'thismonth'}>This month</MenuItem>
                    <MenuItem value={'lastmonth'}>Last month</MenuItem>
                    <MenuItem value={'custom'}>Custom</MenuItem>
                  </TextField>
                </Box>
                {timecustom ? ( 
                  <Box >
                    <TextField
                      id="fromdate"
                      label="From date"
                      type="date"
                      defaultValue={fromDate}
                      value={fromDate}
                      InputProps={{classes: {input: classes.textItemFont}}}
                      className={classes.selectionOptions}
                      onChange={e => setFromDate(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      id="todate"
                      label="To date"
                      type="date"
                      defaultValue={toDate}
                      value={toDate}
                      InputProps={{classes: {input: classes.textItemFont}}}
                      className={classes.selectionDateOptions}
                      onChange={e => setToDate(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                ) : ( '' ) }
                <Box >
                  <Button className={classes.searchButton} variant="contained" onClick={filterOrderList}>
                      <Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Search</Box>
                  </Button>
                </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                  {orderRows.length >= 1 ? ( 
                    <div className={classes.formtable}>
                      {orderRows.map((item, i) =>
                        <OrderItem key={i} item={item} userid={uState.userid} ident={sState.ident} handleClick={handleDownloadClick} handleDataRefreshClick={handleDataRefreshClick}/>
                      )}
                    </div>
                  ) : ( 
                    <Box fontWeight="fontWeightRegular" fontSize={18} >No orders found.</Box>
                  ) }
                
              </Grid>
          </Grid>
          </DialogContent>
          <DialogActions>
            <Button className={classes.downloadButton} variant="contained" onClick={e => setOpen(false)}>
                    <Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Cancel</Box>
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
